<template>
    <div class="card-body pt-3">
        <form>
            <div v-for="(item, index) in selectedServices" class="row g-3 pb-3">
                <div class="col-sm-6">
                    <div class="form-group">
                        <div class="form-line">
                            <label for="service" class="form-label">Select Address <span class="text-danger">*</span></label>
                            <Select2
                                v-model="item.address_id"
                                :options="addressOptions"
                                :settings="{ minimumResultsForSearch: 'Infinity', placeholder: 'Select Service'}"
                                :class="{ 'is-invalid': !isValidated && item.address_id==='' }"
                                @select="getAddressContactPerson(index)"
                            />
                            <div class="is-invalid invalid-feedback">This field is required.</div>
                        </div>
                    </div>
                </div>
                <div v-if="businessOrIndividual === 'business'" class="col-sm-6">
                    <div class="form-group">
                        <div class="form-line">
                            <label for="service" class="form-label">Select Contact Person <span class="text-danger">*</span></label>
                            <Select2
                                v-model="item.address_contact_person"
                                :options="addressContactPersonOptions"
                                :settings="{ minimumResultsForSearch: 'Infinity', placeholder: 'Select Contact Person'}"
                                :class="{ 'is-invalid': !isValidated && item.address_contact_person==='' }"
                            />
                            <div class="is-invalid invalid-feedback">This field is required.</div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group">
                        <div class="form-line">
                            <label for="service" class="form-label">Select Service <span class="text-danger">*</span></label>
                            <Select2
                                v-model="item.id"
                                :options="serviceOptions"
                                :settings="{ minimumResultsForSearch: 'Infinity', placeholder: 'Select Service'}"
                                :class="{ 'is-invalid': !isValidated && item.id==='' }"
                                @select="selectService(item, index)"
                            />
                            <div class="is-invalid invalid-feedback">This field is required.</div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group">
                        <div class="form-line">
                            <label for="due_date" class="form-label">Due Date <span class="text-danger">*</span></label>
                            <div class="d-flex">
                                <input
                                    type="date"
                                    class="form-control required"
                                    id="due_date"
                                    v-model="item.due_date"
                                    :class="{ 'is-invalid': !isValidated && item.due_date==='' }"
                                    :min="minDatetime"
                                >
                                <button
                                    v-if="Object.keys(selectedServices).length > 1"
                                    type="button"
                                    class="btn btn-danger btn-sm ms-2 float-end"
                                    @click="removeService(item, index)"
                                ><i class="bi bi-x"></i></button>
                            </div>

                            <div class="is-invalid invalid-feedback">This field is required.</div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group">
                        <div class="form-line">
                            <label for="due_date" class="form-label">Amount <span class="text-danger">*</span></label>
                            <input
                                type="number"
                                class="form-control required"
                                id="due_date"
                                v-model="item.price"
                                :class="{ 'is-invalid': !isValidated && item.price==='' }"
                            >
                            <div class="is-invalid invalid-feedback">This field is required.</div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                v-if="addMoreBtnVisible"
                class="d-flex pt-10 justify-content-md-end justify-content-center mb-3"
            >
                <button type="button" class="btn btn-theme btn-sm" @click="addMore">Add More</button>
            </div>
            <div class="d-flex pt-20 mb-20 justify-content-md-end justify-content-center">
                <button
                    type="button"
                    class="btn btn-theme"
                    :class="{'disabled': isProcessing}"
                    :disabled="isProcessing"
                    @click="storeUserServices"
                >
                    <template v-if="isProcessing">Processing...</template><template v-else>Save & Next</template>
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import moment from 'moment';
import Select2 from 'vue3-select2-component';
export default {
    props: ['storeUrl', 'customer'],
    components: {
        Select2
    },
    data() {
        return {
            customerObj: {},
            serviceOptions: [],
            services: [],
            selectedServices: [
                {
                    id: '',
                    name: '',
                    price: '',
                    interval: '',
                    due_date: '',
                    service_time: '',
                    customer_id: '',
                    address_id: '',
                    address_contact_person: '',
                },
            ],
            isValidated: true,
            isProcessing: false,
            addMoreBtnVisible: true,
            minDatetime: moment().format('YYYY-MM-DD HH:mm'),
            businessOrIndividual: '', // business or individual
            addresses: [],
            addressOptions: [{id: ' ', text: 'Select Address'}],
            addressContactPersons: [],
            addressContactPersonOptions: [{id: ' ', text: 'Select Contact Person'}],
        }
    },
    mounted() {
        this.customerObj = JSON.parse(this.$props.customer);

        this.selectedServices[0].customer_id = this.customerObj.id;
        this.businessOrIndividual = this.customerObj.account_type;

        this.getServices();
        this.getAddresses();
    },
    methods: {
        getServices() {
            let self = this;
            axios.post('/admin/users/get-recurring-services', {})
                .then(response => {
                    self.services = response.data.services;

                    // Prepare service options
                    self.serviceOptions = [{id: ' ', text: 'Select Service'}];
                    response.data.services.forEach((service) => {
                        self.serviceOptions.push({id: service.id, text: service.name});
                    });
                });
        },
        addMore() {
            // Check if services and selected services length is same then add more button will be disabled
            if (this.services.length == this.selectedServices.length) {
                this.addMoreBtnVisible = false;
                return false;
            }

            this.selectedServices.push({id: '', name: '', price: '', interval: '', service_time: '', due_date: '', customer_id: this.customerObj.id, address_id: '', address_contact_person: ''});
        },
        selectService(item, index) {
            // Find the service
            let service = this.services.find(service => service.id == item.id);
            this.selectedServices[index].name = service.name;
            this.selectedServices[index].price = service.price;
            this.selectedServices[index].interval = service.service_interval;
            this.selectedServices[index].service_time = service.service_time;

            //this.updateServiceOptions(item, 'remove');
        },
        removeService(item, index) {
            this.selectedServices.splice(index, 1);
            //this.updateServiceOptions(item, 'add');
        },
        updateServiceOptions(item, action) {
            if (action == 'add') {
                this.serviceOptions.push({id: item.id, text: item.name});
            }
            else if (action == 'remove') {
                this.serviceOptions = this.serviceOptions.filter(service => service.id != item.id);
            }
        },
        storeUserServices() {
            let self = this;
            this.isValidated = true;
            this.isProcessing = true;
            if (this.selectedServices.length > 0) {
                axios.post(this.$props.storeUrl, {services: this.selectedServices})
                    .then(response => {
                        // Display message
                        self.$notification(response.data.status, response.data.message);
                        if (response.data.status === 'success') {
                            window.location.href = response.data.redirect_url;
                        }

                        self.isProcessing = false;
                    })
                    .catch(error => {
                        let message = error.response.data.message;
                        self.$notification('error', message);
                        self.isProcessing = false;
                    });


            }
        },
        getAddresses() {
            let self = this;

            // Call the API to get user contact persona and address
            axios.post('/admin/users/contact-persons-and-address', {user_id: this.customerObj.id, status: 'active'})
                .then(response => {
                    self.addresses = response.data.addresses;
                    self.businessOrIndividual = response.data.user.account_type;

                    // Prepare the address options
                    self.addressOptions = [{id: ' ', text: 'Select Address'}];
                    response.data.addresses.forEach((address) => {
                        self.addressOptions.push({id: address.id, text: address.full_address});
                    });

                    // If there is only one address then set it as default
                    // if (self.addresses .length == 1) {
                    //     self.selectedServices[0].address_id = self.addresses[0].id;
                    // }
                });
        },
        // Get address contact person
        getAddressContactPerson(index) {
            if (this.businessOrIndividual === 'business') {
                let self = this;
                let item = this.selectedServices[index];

                // Call the API to get user contact persona and address
                axios.post('/admin/users/business-contact-persons', {user_id: self.customerObj.id, address_id: item.address_id})
                    .then(response => {
                        self.addressContactPersons = response.data.users;
                        self.addressContactPersonOptions = [{id: ' ', text: 'Select Contact Person'}]
                        response.data.users.forEach((user) => {
                            self.addressContactPersonOptions.push({id: user.id, text: user.full_name});
                        });
                    });
            }
        }
    },
    watch: {
        selectedServices: {
            handler(newVal, oldVal) {
                //console.log(`New value: ${newVal}, Old value: ${oldVal}`);
                // Iterate through each object in the array
                newVal.forEach((service, index) => {
                    // console.log(`Index: ${index}, Service: ${service.id}`);
                    // console.log(`Index: ${index}, Service: ${oldVal[index].id}`);
                    // Check if the id property has changed
                    if (service.id !== oldVal[index].id) {
                        //console.log(`ID of service at index ${index} has been updated.`);
                        // Do something here when the ID is updated
                    }
                });
            },
            deep: true // This ensures that changes within the objects are watched
        }
    }
}
</script>
